<template lang="pug">
  .toggleable-button
    button(:class="buttonClass", :disabled="disabled", @click="handleClick", :value="value")
      slot
</template>

<script>
  export default {
    name: 'ToggleableButton',
    data() {
      return {
        toggled: this.active
      }
    },
    computed: {
      buttonClass() {
        return this.value ? 'active' : null
      },
    },
    methods: {
      handleClick() {
        if (this.selectable) {
          this.$emit('input', !this.value)
        }
      }
    },
    props: {
      disabled: {
        type: Boolean,
      },
      selectable: {
        type: Boolean,
      },
      value: {
        type: Boolean,
      },
    }
  }
</script>

<style lang="sass">
  .toggleable-button
    button
      padding: 10px 20px
      background: #fafafa
      cursor: pointer
      border-radius: 0
      // border: 1px solid #ededed
      &:disabled
        background: red
        color: white

      &.active
        color: white
        background: green
</style>



// WEBPACK FOOTER //
// ToggleableButton.vue?53ccf9a6